export default "__VITE_ASSET__brNWCxHF__"